import { useLocation, useNavigate } from 'react-router-dom';
import c from 'classnames';

import { useCurrentKitAndTinyAccount } from 'hooks/useCurrentKitAndTinyAccount';
import type { GutVaginalHealthAssociation } from '@repo/types/SubMetricEvaluation';
import { Icon } from '@repo/ui';

import styles from './AssociationsList.module.scss';

export const AssociationsList = ({
  associations,
}: {
  associations?: Omit<GutVaginalHealthAssociation, 'gut_vaginal_health_id'>[];
}) => {
  const { pathname } = useLocation();

  if (!associations?.length) return <></>;

  const { currentKitId } = useCurrentKitAndTinyAccount();

  const navigate = useNavigate();

  const navigateToCondition = (name: string) => {
    navigate(`/results/${currentKitId}/conditions/metrics/${name}`, {
      state: { from: pathname },
    });
  };

  return (
    <div className={styles.associations}>
      {associations?.map(association => {
        // We still have "legacy" Associations and we need to handle them.
        // Legacy Associations shouldn't navigate to a Condition section.
        const hasNewConditionPage = !!association.conditions_metrics;

        return (
          <div
            key={`${association.association_id}-association`}
            className={c(
              styles.associationPill,
              hasNewConditionPage && styles.pillHover,
              styles.wordBreak,
            )}
            onClick={() =>
              hasNewConditionPage &&
              association.association_name &&
              navigateToCondition(association.association_name)
            }
          >
            {!!association?.direction && (
              <div
                className={c(styles.iconWrapper, {
                  [styles.pillPositive]: association?.evaluation === 'good',
                  [styles.pillNegative]: association?.evaluation !== 'good',
                })}
              >
                <Icon
                  name={
                    association?.direction === 'positive'
                      ? 'upSmall'
                      : 'downSmall'
                  }
                  size='s'
                />
              </div>
            )}
            <span className={c(hasNewConditionPage && styles.link)}>
              {association.conditions_metrics
                ? association.conditions_metrics.condition_display_name
                : association.association_name
                  ? association.association_name
                  : association.display_name}
            </span>
          </div>
        );
      })}
    </div>
  );
};
